export default __webpack_public_path__ + "static/media/learningpath4.59a05eab.svg";